import { useLanguage } from "../i18n/LanguageContext";
import { GOOGLE_REVIEWS_URL, GOOGLE_WRITE_REVIEW_URL } from "../content/siteContent";
import { Reveal, Overline } from "./Reveal";
import { IconGoogle, IconStar } from "./Icons";
import GoogleReviewsWidget from "./GoogleReviewsWidget";

const ReviewsSection = () => {
    const { t } = useLanguage();
    return (
        <section id="reviews" className="scroll-mt-24 py-12 md:py-20" aria-labelledby="reviews-title" data-testid="reviews-section">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <Reveal>
                    <div className="flex flex-wrap items-end justify-between gap-6">
                        <div className="max-w-xl">
                            <Overline>{t.reviews.overline}</Overline>
                            <h2 id="reviews-title" className="mt-4 font-display text-3xl font-bold tracking-tight text-ink sm:text-4xl lg:text-5xl">
                                {t.reviews.title}
                            </h2>
                            <p className="mt-4 text-base leading-relaxed text-mist md:text-lg">{t.reviews.subtitle}</p>
                        </div>
                        <div className="flex flex-col items-stretch gap-3 sm:flex-row sm:items-center">
                            <a
                                href={GOOGLE_REVIEWS_URL}
                                target="_blank"
                                rel="noreferrer"
                                data-testid="reviews-summary"
                                className="flex items-center gap-4 rounded-2xl border border-ink/10 bg-surface px-6 py-4 shadow-sm transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-0.5 hover:border-gold-500/50 hover:shadow-[0_20px_40px_-22px_rgba(0,77,77,0.4)]"
                            >
                                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-gold-100 text-pine">
                                    <IconGoogle className="h-5 w-5" />
                                </span>
                                <span>
                                    <span className="flex gap-0.5 text-gold-500" aria-hidden="true">
                                        {Array.from({ length: 5 }).map((_, i) => (
                                            <IconStar key={i} className="h-3.5 w-3.5" />
                                        ))}
                                    </span>
                                    <span className="mt-1 block text-sm font-semibold text-ink">
                                        <span dir="ltr">{t.reviews.rating}</span> · {t.reviews.aggregate}
                                    </span>
                                </span>
                            </a>
                            <a
                                href={GOOGLE_WRITE_REVIEW_URL}
                                target="_blank"
                                rel="noreferrer"
                                data-testid="reviews-write-button"
                                className="flex items-center gap-4 rounded-2xl border border-ink/10 bg-surface px-6 py-4 shadow-sm transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-0.5 hover:border-gold-500/50 hover:shadow-[0_20px_40px_-22px_rgba(0,77,77,0.4)]"
                            >
                                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-gold-100 text-pine">
                                    <IconStar className="h-5 w-5" />
                                </span>
                                <span className="text-start text-sm font-semibold text-ink">{t.reviews.writeUs}</span>
                            </a>
                        </div>
                    </div>
                </Reveal>
                <Reveal delay={0.1} className="mt-10">
                    <GoogleReviewsWidget />
                </Reveal>
            </div>
        </section>
    );
};

export default ReviewsSection;
